import { Expose, Transform } from 'class-transformer';
import { PathInfos } from '@madeinlune/drupal-types';
import { ImageMedia } from './media.model';
import { createMedium } from './entities-utils';
import { LanguageType } from '../languages.model';

export class DrupalIdentifier {
  @Expose()
  type!: string;

  @Expose()
  id!: string;
}

export class DrupalCommon extends DrupalIdentifier implements PathInfos {
  @Transform(({ obj }) => {
    return obj?.attributes?.updatedOn;
  })
  @Expose()
  changed?: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.createdOn * 1000;
  })
  @Expose()
  created?: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.langcode;
  })
  @Expose()
  language!: LanguageType;

  @Transform(({ obj }) => {
    return obj?.attributes?.title;
  })
  @Expose()
  title!: string;

  @Transform(({ obj }) => {
    return `/${obj?.attributes?.langcode}${obj?.attributes?.path}/`;
  })
  @Expose()
  path = '';

  @Transform(({ obj }) => {
    return obj?.attributes?.isPromoted === true;
  })
  @Expose()
  promote?: boolean;

  @Transform(({ obj }) => {
    return obj?.attributes?.sticky === true;
  })
  @Expose()
  sticky?: boolean;

  thumb?: string;

  /*@Transform(({ obj }) => {
    if (obj?.relationships?.thumbnail?.data) {
      const { reference, meta, ...rest } = obj.relationships.thumbnail.data;
      return rest;
    }
    return null;
  })
  @Expose()
  thumbnail?: ResourceIdentifier;*/

  @Transform(({ obj }) => {
    return createMedium(obj?.relationships?.thumbnail?.data?.reference);
  })
  @Expose()
  thumbnail!: ImageMedia | undefined;

  @Transform(({ obj }) => {
    const rawTranslations = obj?.meta?.drupal?.translations;
    const translations: Translations = {};
    if (rawTranslations) {
      Object.keys(rawTranslations).forEach((key) => {
        const rawTranslation: any = rawTranslations[key];
        const { id, isDefault, path, name } = rawTranslation;
        const translation: Translation = {
          language: id,
          isDefault,
          name,
          path: `/${id}${path}`,
        };
        translations[key] = translation;
      });
    }
    return translations;
  })
  @Expose()
  translations?: Translations;

  @Transform(({ obj }) => {
    return obj?.attributes?.summary;
  })
  @Expose()
  summary?: string;

  description!: string;
}

export class DrupalNode extends DrupalCommon {}

export interface Translations {
  [language: string]: Translation;
}

export interface Translation {
  language: string;
  isDefault: boolean;
  name: string;
  path: string;
}
